<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Portfolio</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Nama Project Portofolio</p>
              <v-text-field
                outlined
                v-model="form.program"
                class="form-input"
                placeholder="Masukan Nama Project Portofolio"
                dense
                :disabled="isWatch"
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Nama Klien</p>
              <v-text-field
                outlined
                v-model="form.title"
                class="form-input"
                placeholder="Masukan Nama Klien"
                dense
                :disabled="isWatch"
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Waktu Project Dibuat</p>
              <v-menu
                ref="startPicker"
                v-model="startPicker"
                :close-on-content-click="false"
                :return-value.sync="form.start_date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    placeholder="Tetapkan waktu Project Dibuat"
                    class="form-input"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    :disabled="isWatch"
                  >
                    <template v-slot:append>
                      <Calendar style="cursor: pointer"></Calendar>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="form.start_date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="startPicker = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.startPicker.save(form.start_date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="content-form">
              <p>Kategori Portofolio</p>
              <v-select
                class="form-input"
                :items="categories"
                :item-text="'name'"
                :item-value="'value'"
                v-model="form.category"
                :disabled="isWatch"
                outlined
              ></v-select>
            </div>
            <div class="content-form">
              <p>Tampilan Inti</p>
              <div class="spacing-switch">
                <v-switch
                  v-model="form.is_main"
                  color="primary"
                  hide-details
                  :disabled="isWatch"
                  style="margin-top: -5px"
                ></v-switch>
                <div>
                  <Chip :active="form.is_main" />
                </div>
              </div>
            </div>
            <div class="content-form">
              <p>Status</p>
              <div class="spacing-switch">
                <v-switch
                  v-model="form.is_active"
                  color="primary"
                  hide-details
                  :disabled="isWatch"
                  style="margin-top: -5px"
                ></v-switch>
                <div>
                  <Chip :active="form.is_active" />
                </div>
              </div>
            </div>
            <div class="content-form">
              <p>Link Project</p>
              <v-text-field
                outlined
                v-model="form.link_project"
                class="form-input"
                placeholder="Masukan Link Project"
                dense
                clearable
                :disabled="isWatch"
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Pilih Device</p>
              <v-select
                :disabled="isWatch"
                v-model="form.device"
                :items="deviceList"
                multiple
                chips
                persistent-hint
                outlined
                item-text="name"
                return-object
                class="form-input"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Teknologi</p>
              <v-select
                :disabled="isWatch"
                v-model="form.technology"
                :items="technologyList"
                multiple
                chips
                persistent-hint
                outlined
                item-text="name"
                return-object
                class="form-input"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Lingkup Project</p>
              <v-select
                :disabled="isWatch"
                v-model="form.scope_project"
                :items="scopeProjectList"
                multiple
                chips
                persistent-hint
                outlined
                item-text="name"
                return-object
                class="form-input"
              ></v-select>
            </div>
            <div class="content-form">
              <p>Deskripsi Singkat</p>
              <v-textarea
                outlined
                :disabled="isWatch"
                v-model="form.description"
                class="form-input"
                placeholder="Tulis di sini..."
                rows="4"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Detail Project</p>
              <vue-editor
                v-model="form.body"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="form.body"></div>
              </div>
            </div>
            <div class="content-form">
              <p>Deskripsi Tanggung Jawab Kami</p>
              <vue-editor
                v-model="form.responsibility"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="form.responsibility"></div>
              </div>
            </div>
            <div class="content-form">
              <p>Berkas Gambar Thumbnail</p>
              <v-file-input
                v-model="img_portfolio"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template
                  v-slot:prepend-inner
                  v-if="isEdit && img_portfolio == null"
                >
                  <ImageModal
                    :src="form.image_url"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">
                Ungah file dalam format SVG dengan dimensi 56x56, maksimal 1 MB
              </p>
            </div>
          </div>
        </div>
        <div class="cart-form mt-5">
          <v-card-title class="card-form-head-2">
            <h1>Dokumentasi Project</h1>
          </v-card-title>
          <div class="content-form mt-5">
            <div
              class="list-event mt-2"
              v-for="(item, idx) in form.key_feature"
              :key="idx"
            >
              <p>Gambar Pendukung</p>
              <div
                class="icon-plus-bc"
                @click="form.key_feature.splice(idx, 1)"
                v-if="!isWatch"
              >
                <trash-icon :width="25" :height="25" />
              </div>
              <v-file-input
                v-model="form.key_feature[idx].img_mo"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                :disabled="isWatch"
                outlined
              >
                <template
                  v-slot:prepend-inner
                  v-if="form.key_feature[idx].img_mo == null"
                >
                  <ImageModal
                    :src="form.key_feature[idx].img"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">
                Ungah file dalam format SVG dengan dimensi 56x56, maksimal 1 MB
              </p>
            </div>
            <div class="add-button" @click="addKeyFeature" v-if="!isWatch">
              <div class="line"></div>
              <div class="button">+ Tambah Gambar</div>
              <div class="line"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Portfolio Project Name</p>
              <v-text-field
                outlined
                v-model="formEng.program"
                class="form-input"
                placeholder="Enter Portfolio Project Name"
                dense
                :disabled="isWatch"
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Client Name</p>
              <v-text-field
                outlined
                v-model="formEng.title"
                class="form-input"
                placeholder="Enter Client Name"
                dense
                :disabled="isWatch"
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Short Description</p>
              <v-textarea
                outlined
                :disabled="isWatch"
                v-model="formEng.description"
                class="form-input"
                placeholder="Write here..."
                rows="4"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Project Details</p>
              <vue-editor
                v-model="formEng.body"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="formEng.body"></div>
              </div>
            </div>
            <div class="content-form">
              <p>Our Responsibility Description</p>
              <vue-editor
                v-model="formEng.responsibility"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="formEng.responsibility"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/project-portfolio')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "@/components/Button.vue";
import ImageModal from "@/components/ImageModal.vue";
import Popup from "@/components/others/Popup.vue";
import { VueEditor } from "vue2-editor";
import TrashIcon from "@/components/icons/Trash.vue";
import Chip from "@/components/Chip.vue";
import Arrow from "@/components/icons/Arrow.vue";
import Calendar from "@/components/icons/Calendar.vue";

export default {
  name: "FormProjectPortfolio",
  components: {
    Loading,
    Button,
    ImageModal,
    Popup,
    VueEditor,
    TrashIcon,
    Chip,
    Arrow,
    Calendar,
  },
  computed: {
    validData() {
      return (
        this.form.title &&
        this.form.program &&
        this.form.category &&
        (this.isEdit || this.img_portfolio)
      );
    },
  },
  data() {
    return {
      id: null,
      startPicker: false,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      img_portfolio: null,
      form: {
        title: "",
        is_main: false,
        is_active: true,
        program: "",
        description: "",
        category: "",
        image_url: "",
        start_date: "",
        responsibility: "",
        link_project: "",
        technology: [],
        device: [],
        key_feature: [],
        scope_project: [],
        body: "",
      },
      formEng: {
        title: "",
        program: "",
        description: "",
        responsibility: "",
        body: "",
      },
      scopeProjectList: [
        { name: "IT Consulting", value: "/img/portfolio/it_consulting.png" },
        { name: "IT Sourcing", value: "/img/portfolio/it_sourcing.png" },
        { name: "IT Implementation", value: "/img/portfolio/it_implementation.png" },
        { name: "IT Support", value: "/img/portfolio/it_support.png" },
      ],
      technologyList: [
        { name: "HTML5", value: "/img/portfolio/html.png" },
        { name: "CSS3", value: "/img/portfolio/css.png" },
        { name: "JS", value: "/img/portfolio/js.png" },
        { name: "React", value: "/img/portfolio/react.png" },
        { name: "Laravel", value: "/img/portfolio/laravel.png" },
        { name: "MySql", value: "/img/portfolio/mysql.png" },
      ],
      deviceList: [{ name: "Mobile" }, { name: "Website" }, { name: "Desktop" }],
      categories: [
        { name: "Collaboration", value: "COLLABORATION" },
        { name: "Training", value: "TRAINING" },
        { name: "Talent Service", value: "TALENT_SERVICE" },
        { name: "Services", value: "SERVICES" },
      ],
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getDataProjectPortfolio();
    },
    addKeyFeature() {
      this.form.key_feature.push({
        img_mo: null,
        img: "",
      });
    },
    async getDataProjectPortfolio() {
      this.isLoading = true;
      try {
        const resp = await this.$crm_http.get("/v1/project-portfolio/" + this.id);
        const data = resp.data.data.project_portfolio;
        this.form = {
          title: data.title || "",
          is_main: data.is_main || false,
          is_active: data.is_active || true,
          program: data.program || "",
          description: data.description || "",
          category: data.category || "",
          image_url: data.image_url || "",
          start_date: data.start_date || "",
          responsibility: data.responsibility || "",
          link_project: data.link_project || "",
          technology: data.technology || [],
          device: data.device || [],
          key_feature: data.key_feature || [],
          scope_project: data.scope_project || [],
          body: data.body || "",
          id: data.id,
        };
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=project_portfolio&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          title: resp.title || "",
          program: resp.program || "",
          description: resp.description || "",
          responsibility: resp.responsibility || "",
          body: resp.body || "",
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        let imageUrl = this.form.image_url;

        if (this.img_portfolio) {
          const imageForm = new FormData();
          imageForm.append("attachment", this.img_portfolio);
          const webRes = await this.$crm_http.post("/v1/upload-file", imageForm);
          imageUrl = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete("attachment");
        }

        for (const project of this.form.key_feature) {
          if (project.img_mo) {
            const formData = new FormData();
            formData.append("attachment", project.img_mo);
            const { data } = await this.$crm_http.post("/v1/upload-file", formData);
            project.img = data.data.upload_image_response.url_w_query;
            delete project.img_mo;
            formData.delete("attachment");
          }
        }

        const payload = {
          title: this.form.title,
          is_main: this.form.is_main,
          is_active: this.form.is_active,
          program: this.form.program,
          description: this.form.description,
          category: this.form.category,
          image_url: imageUrl,
          start_date: this.form.start_date,
          responsibility: this.form.responsibility,
          link_project: this.form.link_project,
          technology: this.form.technology,
          device: this.form.device,
          key_feature: this.form.key_feature,
          scope_project: this.form.scope_project,
          body: this.form.body,
        };

        if (this.isEdit) {
          await this.$crm_http.put("/v1/project-portfolio/" + this.form.id, payload);
          await this.onSubmitBilingual(imageUrl);
        } else {
          await this.$crm_http.post("/v1/project-portfolio", payload);
        }

        setTimeout(() => {
          this.$router.push("/project-portfolio");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual(imageUrl) {
      const payload = {
        table_name: "project_portfolio",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          title: this.formEng.title,
          program: this.formEng.program,
          description: this.formEng.description,
          responsibility: this.formEng.responsibility,
          body: this.formEng.body,
          category: this.form.category,
          is_main: this.form.is_main,
          is_active: this.form.is_active,
          image_url: imageUrl,
          start_date: this.form.start_date,
          link_project: this.form.link_project,
          technology: this.form.technology,
          device: this.form.device,
          key_feature: this.form.key_feature,
          scope_project: this.form.scope_project,
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.form-upload .v-input__slot {
  height: 62px !important;
  background-color: #ffffff !important;
}
.form-upload .v-text-field__details {
  display: none;
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.note-file {
  font-weight: 400;
  font-size: 12px;
  color: #b80f0a;
  margin-bottom: 20px !important;
}
.spacing-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}
.watch-ctn {
  padding: 15px;
  border-radius: 15px;
  border: 1px solid gray;
}
.list-event {
  margin-top: 15px;
  position: relative;
  margin-left: 60px;
}
.icon-plus-bc {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -56px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f5f6fa;
}
.add-button {
  margin: 15px;
  display: flex;
  align-items: center;
  gap: 20px;
}
.add-button .line {
  width: 40%;
  background-color: #d3d6e1;
  height: 2px;
}
.add-button .button {
  min-width: max-content;
  padding: 7px 20px;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid #d3d6e1;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>